export abstract class DashboardConfigService {
  public static FeedbackFormURL: string;
  public static HelpUrl: string;
  public static GTMId: string;
}
